<ngx-doc-viewer [url]="url" [viewer]="viewType" [disableContent]="disableTool" (loaded)="fileLoaded($event)">
</ngx-doc-viewer>
<!-- <ngx-doc-viewer [ngStyle]="{'width.px': width, 'height.px': height}" [url]="url" [viewer]="viewType">
</ngx-doc-viewer> -->